import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function PlaceOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a2 2 0 11.001-4.001A2 2 0 0112 11z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22s-.53-.588-1.3-1.55C8.675 17.92 5 12.805 5 9c0-3.87 3.13-7 7-7s7 3.13 7 7c0 3.804-3.675 8.92-5.7 11.45C12.53 21.413 12 22 12 22zm1.842-5.65c-.644.955-1.29 1.82-1.842 2.522a43.664 43.664 0 01-1.842-2.522c-.837-1.24-1.646-2.598-2.239-3.922C7.314 11.078 7 9.908 7 9c0-2.765 2.235-5 5-5s5 2.235 5 5c0 .908-.314 2.078-.919 3.428-.593 1.324-1.402 2.681-2.239 3.922z"
  }));
}
export default PlaceOutlineIcon;